exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loginLsContain .el-form-item__content{line-height:normal}.loginLsContain .el-input__inner{color:#999;height:52px}.loginLsContain .el-form-item{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js??ref--2-2!./src/statics/css/loginLs.scss
// module id = 616
// module chunks = 1